<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import womanMeasuringWithIndowLaserImg from './images/LP-Snug-Fit-01.png';
	import installedWindowInsertImg from './images/LP-Snug-Fit-02.jpg';
</script>

<Section backgroundColor="blue" class="[&_p]:text-left">
	<h1>Snug Fit Guarantee</h1>
	<p>
		The Indow Snug Fit Guarantee is designed to help you measure with confidence
		and know we are here to support you. Indow boasts a 99.8% first time fit, so
		you can believe in yourself and our process. We look forward to bringing you
		comfort and quiet.
	</p>
	<Image
		src={womanMeasuringWithIndowLaserImg}
		class="no-bleed"
		loading="eager"
	/>
	<p>
		The Indow Measure System uses six dimensions to measure the inside of your
		window frame. These are entered into the Measure by Indow® portal to
		calculate the shape of your window and allows us to build an insert to
		create a near airtight seal.
	</p>
	<p>
		The Indow Snug Fit Guarantee applies to measurements submitted via the
		Measure by Indow portal and is dependent upon certain conditions.
	</p>
</Section>

<Section class="[&_p]:text-left">
	<h2
		class="
    text-left text-lg
    md:text-center
  "
	>
		THE INDOW SNUG FIT GUARANTEE APPLIES TO MEASUREMENTS SUBMITTED VIA THE
		MEASURE BY INDOW PORTAL AND IS DEPENDENT UPON CERTAIN CONDITIONS
	</h2>
	<ol
		class="
    list-decimal
    marker:font-bold
  "
	>
		<li>
			<p>
				To be eligible for the Snug Fit Guarantee, you must report the presence
				of any of the following conditions. Failure to communicate these
				conditions will nullify the Snug Fit Guarantee. These conditions may
				cause fit issues if not communicated during the measurement process:
			</p>
			<ol
				class="
      list-[lower-alpha]
      marker:text-black
    "
			>
				<li><p>Bowed frames (see instructions for details)</p></li>
				<li>
					<p>
						Rounded corners or buildup in the corners due to paint or other
						debris
					</p>
				</li>
				<li>
					<p>
						Obstructions in the window sill: existing window hardware or blinds
					</p>
				</li>
				<li>
					<p>
						Irregular surfaces at time of measurement: textured material or
						uneven concrete such as grout or mortar joints
					</p>
				</li>
				<li>
					<p>
						Inadequate frame depth: Indow inserts require ⅝” of flat,
						unobstructed space perpendicular to the window, or 1 ¼” behind
						blinds or similar where compression may be restricted
					</p>
				</li>
				<li>
					<p>
						Inappropriate applications: exterior side of window, fireplace
						opening, door (Indow inserts are designed as secondary glazing to be
						used on the inside of the home or building and are unsupported for
						alternative applications unless express written consent from Indow
						is provided)
					</p>
				</li>
				<li>
					<p>
						Transcription errors, omissions, or negligence: duplicate entries
						for the same window opening when a second opening was intended
					</p>
				</li>
			</ol>
		</li>
		<li>
			<p>
				To qualify for the Snug Fit Guarantee, you must only use Indow processes
				to take the measurements and upload them to our system as directed.
			</p>
		</li>
		<li>
			<p>
				Any errors or warnings regarding measurements which are presented within
				the Measure by Indow portal must be resolved by accurately reconfirming
				the dimensions prior to proceeding.
			</p>
		</li>
	</ol>
</Section>

<Section
	imageColumn={installedWindowInsertImg}
	loading="lazy"
	columnPosition="left"
	backgroundColor="grey-light"
	class="
   [&_p]:text-left
   md:[&_p]:max-w-prose
 "
>
	<h2
		class="
    w-full text-left
    md:text-center
  "
	>
		If An Insert Doesn't Fit
	</h2>
	<p>
		If you qualify for our Snug Fit Guarantee and your insert does not fit, you
		will need to <a href="/claim-submission-customer">
			complete our warranty claim process</a
		>. If your fit issue can be solved with our Frame Fit Kit, it will be sent
		to you at no cost. If the issue cannot be corrected with the hardware in the
		Frame Fit Kit, we will replace your insert at no cost to you, subject to a
		limitation of $2,500 per order. If you opt out of the Frame Fit Kit when it
		is a viable solution, we will provide a 50% discount on a new insert.
	</p>
	<p>
		In the event that a replacement insert is warranted, we may request
		remeasurements (or a new template for special geometry windows). If you
		measured with our laser, we will send a Laser Measure Kit if needed at no
		additional cost. Failure to provide remeasured values for a replacement
		insert within 30 days of our request will invalidate the Snug Fit Guarantee.
	</p>
	<p>
		If, after receiving remeasure values, we are unable to determine the reason
		for your fit issue, Indow reserves the right, but not the obligation, to
		refund your purchase price for the Indow insert(s) in question, as an
		alternative to replacement.
	</p>
	<p>
		Any claims made to Indow must be made within 30 days of the shipment
		delivery date to qualify for the Snug Fit Guarantee.
	</p>
	<p>Effective as of 6/22/2022.</p>
</Section>
